import React from "react";
import FaqItem from "./FaqItem";
import { faqs_wrapper } from "../../styles/modules/faqs.module.css";

function Faqs({
  title = "Preguntas frecuentes",
  items = [{ question: "Pregunta 1", answer: "Respuesta 1" }],
}) {
  // const faqJsonLdData = {
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   mainEntity: items.map(item => {
  //     return {
  //       "@type": "Question",
  //       name: item.question,
  //       acceptedAnswer: {
  //         "@type": "Answer",
  //         text: item.answer,
  //       },
  //     };
  //   }),
  // };

  // <script
  //       type="application/ld+json"
  //       dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLdData) }}
  //     />

  return (
    <section className={faqs_wrapper}>
      <h2>{title}</h2>
      <div>
        {items.map((item, index) => (
          <FaqItem item={item} key={item.question} index={index} />
        ))}
      </div>
    </section>
  );
}

export default Faqs;
